module.exports = __webpack_public_path__ + "static/media/undraw_investing_7u74.2a917a14.svg";